import { fg } from '@atlassian/jira-feature-gating';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { LICENSED_PRODUCTS } from '@jira/platform__get-tenant-context/src/index.tsx';
import { safeCloneResource } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';

export const navigationSidebarAutomationLegacyEnabledResource: RouteResource<{
	enabled: boolean;
}> = safeCloneResource(
	createResource<{
		enabled: boolean;
	}>({
		type: 'AUTOMATION_IS_LEGACY_ENABLED',
		getKey: ({ query }) => `jsm-legacy-automation-enabled-${query.projectKey}`,
		getData: async (_, { tenantContext: { licensedProducts } }) => {
			const defaultValue = { enabled: true };
			if (!licensedProducts || !licensedProducts[LICENSED_PRODUCTS.JIRA_SERVICEDESK]) {
				return defaultValue;
			}
			const { enabled } = await performGetRequest('/rest/servicedesk/automation/1/legacy/state');
			return { enabled };
		},
		maxAge: Infinity,
	}),
	{
		get isPageShellCritical() {
			return !fg('jira_ssr_demote_optional_critical_resources');
		},
	},
);
